import { render, staticRenderFns } from "./delete-goal-modal.vue?vue&type=template&id=d9fdf02c&"
import script from "./delete-goal-modal.vue?vue&type=script&lang=ts&"
export * from "./delete-goal-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports